'use strict';

import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

const SELECTOR = '.js-pull-quote';

export function initialiseElement(element) {
    const scrollerElement = element.querySelector('.swiper-container');
    const paginationElement = element.querySelector('.swiper-pagination');
    const totalSlides = scrollerElement.querySelectorAll('.swiper-slide').length;

    const settings = {
        slidesPerView: '1',
        grabCursor: false,
        effect: 'fade',
        crossFade: 'true',
        pagination: {
            el: paginationElement,
            type: 'bullets',
            bulletElement: 'button',
            clickable: true,
            renderBullet(index, className) {
                return `<button class="${className}"><span class="visually-hidden">Slide ${index + 1} of ${totalSlides}</span></button>`;
            },
        },
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
        },
        modules: [Pagination, Autoplay, EffectFade],
    };

    // Initialize Swiper instance
    new Swiper(scrollerElement, settings);
}

export default function () {
    document.querySelectorAll(SELECTOR).forEach(initialiseElement);
}
